// ============================================
// CHANGE API HERE
// ============================================
const DEFILLAMA_STABLECOINS_API = 'https://stablecoins.llama.fi/stablecoins?includePrices=true';
const USE_MOCK_DATA = false; // Set to true to use mock data for development

// M2 Money Supply - Update this value periodically from official sources
// Source: Federal Reserve Economic Data (FRED) - https://fred.stlouisfed.org/series/M2SL
// Last updated: January 2026
const M2_MONEY_SUPPLY_USD = 21100000000000; // $21.1 trillion

// ============================================
// MAIN FETCH FUNCTION
// ============================================
export async function fetchMetrics() {
  try {
    if (USE_MOCK_DATA) {
      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock data for development
      const mockResponse = {
        stablecoin_market_cap: 168500000000, // $168.5 billion
        m2_money_supply: 21100000000000, // $21.1 trillion
        timestamp: new Date()?.toISOString()
      };
      
      return parseApiResponse(mockResponse);
    }
    
    // Real API call to DeFillama
    const response = await fetch(DEFILLAMA_STABLECOINS_API);
    if (!response?.ok) {
      throw new Error(`DeFillama API request failed: ${response.status}`);
    }
    
    const data = await response?.json();
    return parseApiResponse(data);
    
  } catch (error) {
    console.error('Error fetching metrics:', error);
    throw error;
  }
}

// ============================================
// CHANGE PARSING HERE
// ============================================
function parseApiResponse(apiData) {
  // For mock data
  if (apiData?.stablecoin_market_cap) {
    return {
      stablecoins_usd: apiData?.stablecoin_market_cap || 0,
      m2_usd: apiData?.m2_money_supply || M2_MONEY_SUPPLY_USD,
      last_updated: apiData?.timestamp || new Date()?.toISOString()
    };
  }
  
  // For DeFillama API response
  // DeFillama returns an object with peggedAssets array containing all stablecoins
  // We need to sum up the circulating amounts to get total market cap
  let totalStablecoinMarketCap = 0;
  
  if (apiData?.peggedAssets && Array.isArray(apiData?.peggedAssets)) {
    totalStablecoinMarketCap = apiData?.peggedAssets?.reduce((sum, stablecoin) => {
      // Each stablecoin has a 'circulating' object with chain-specific amounts
      const circulatingData = stablecoin?.circulating || {};
      const peggedUSD = circulatingData?.peggedUSD || 0;
      return sum + peggedUSD;
    }, 0);
  }
  
  return {
    stablecoins_usd: totalStablecoinMarketCap,
    m2_usd: M2_MONEY_SUPPLY_USD,
    last_updated: new Date()?.toISOString()
  };
}
